import type { ApiOrder, Order } from '../types';

import { deriveDisplayName, deriveOrderCode } from './codes';
import { isDisplayStatus, laneFor, parseStatus } from './status';

/**
 * Maps a raw API order to the in-memory shape used by the rendering and
 * sorting layers. Returns null when the order is unrenderable - missing id,
 * unknown / cancelled status, etc - so the caller can simply skip it.
 */
export function normaliseOrder(api: ApiOrder | null | undefined): Order | null {
  if (!api || !api.id) return null;

  const status = parseStatus(api.status);
  if (!status || !isDisplayStatus(status)) return null;

  return {
    id: api.id,
    externalId: api.externalId,
    title: deriveDisplayName(api.title),
    code: deriveOrderCode(api),
    status,
    lane: laneFor(status),
    createdAt: api.createdAt,
    updatedAt: api.updatedAt,
    pickupAt: api.pickupAt ?? null,
    priorityScore: typeof api.priorityScore === 'number' ? api.priorityScore : null,
  };
}
